import { render, staticRenderFns } from "./ChangeCategorySection.vue?vue&type=template&id=06ab81e4&scoped=true&"
import script from "./ChangeCategorySection.vue?vue&type=script&lang=js&"
export * from "./ChangeCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCategorySection.vue?vue&type=style&index=0&id=06ab81e4&prod&scoped=true&lang=css&"
import style1 from "./ChangeCategorySection.vue?vue&type=style&index=1&id=06ab81e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab81e4",
  null
  
)

export default component.exports